export default "Estimez les primes CEE BAT-TH, BAT-EN, BAT-EQ applicables à vos immeubles tertiaires. Résultat chiffré avec votre SIRET en 60 secondes.";
